export { default } from './MiniContactPanel';
